var util = angular.module('gymsystem.util');
util.controller('ChainSettingsCtrl', ['$rootScope', '$scope', 'server', 'Setting', '$controller', 'alertProvider', function ($rootScope, $scope, server, Setting, $controller, alertProvider) {
        $controller('ChangeCtrl', { $scope: $scope });
        $scope.item = {};
        $scope.loadingStatus = {};
        $scope.title = null;
        $scope.fields = [
            { name: 'ns', title: 'Name', required: true, type: 'text' },
            { name: 'inactive_workouttype', title: 'Inactive workout type', required: false, type: 'checkbox' }
        ];
        Setting.get('chain').then(function (settings) {
            $scope.item = settings;
            $scope.setValues(settings);
        });
        $scope.getButtonText = function () { return 'Save changes'; };
        $scope.submit = function () {
            $scope.loadingStatus.loading = true;
            var settings = $scope.getSubmitItem();
            Setting.set('chain', settings).then(function () {
                $scope.item = settings;
                alertProvider.show('success', 'Settings saved');
                $scope.loadingStatus.loading = false;
            }, function () {
                alertProvider.show('error', 'Failed to save settings');
                $scope.loadingStatus.loading = false;
            });
        };
    }]);
